export const COLLEGE = {
  name: "Mar Elias College",
  tagline_ml: "പഠിക്കാൻ വൈബ്  പഠിച്ചാൽ ജോബ്",
  tagline_en: "Vibes to learn. A job once you do.",
  address: "Kottappady, Kothamangalam, Ernakulam Dist, Kerala - 686 692",
  address_ml: "കോട്ടപ്പടി, കോതമംഗലം, എറണാകുളം ജില്ല, കേരളം - 686 692",
  phone_primary: "8606602601",
  phone_secondary: "8606842600",
  whatsapp_message:
    "Hi! I'd like to know more about admissions and programs at Mar Elias College.",
  brochure_pdf:
    "https://customer-assets.emergentagent.com/job_future-tech-site-6/artifacts/idaka4z1_MAR_ELIAS_BROCHURE.pdf",
  email: "marelias@mecollege.ac.in",
  website: "www.mecollege.ac.in",
  affiliation:
    "Affiliated to M.G. University · Approved by Govt. of Kerala · NAAC B++",
  est: 2006,
  logo: "https://customer-assets.emergentagent.com/job_9b52cfd5-7dd3-4d4c-a559-5064bb754627/artifacts/ks3rrqfr_WhatsApp_Image_2026-03-31_at_12.16.51_PM-removebg-preview.png",
  hero_bg:
    "https://static.prod-images.emergentagent.com/jobs/9b52cfd5-7dd3-4d4c-a559-5064bb754627/images/3c0acccda1fa2de33fc02ab21d570550d98c76cb4cca84cd3774c428e0af5705.png",
  about_image:
    "https://static.prod-images.emergentagent.com/jobs/9b52cfd5-7dd3-4d4c-a559-5064bb754627/images/91d2cc70ef233f90d84ae6f20ef1a20ad42d2e3c88f6ef5df81e2e73e62f16a4.png",
  campus_life:
    "https://static.prod-images.emergentagent.com/jobs/9b52cfd5-7dd3-4d4c-a559-5064bb754627/images/fa7f8e226417dc5e50d2028576cdf8d109c28dd7c4fd461a9b97242d38582d91.png",
  footer_bg:
    "https://static.prod-images.emergentagent.com/jobs/9b52cfd5-7dd3-4d4c-a559-5064bb754627/images/6cac411d42a1d79c1adff5639a1ad8b09661b05eb7936904d92501f71a7b7cd7.png",
};

export const UG_PROGRAMS = [
  {
    code: "BCA-HONS",
    title: "BCA (Hons.)",
    sub: "Bachelor of Computer Applications",
    icon: "Cpu",
    streams: [
      "AI & Machine Learning",
      "Cybersecurity",
      "Digital Marketing & AI",
      "Robotics",
      "Data Science & AI",
      "Power BI",
      "MERN Stack",
    ],
  },
  {
    code: "BCOM-HONS",
    title: "B.Com (Hons.)",
    sub: "Bachelor of Commerce",
    icon: "TrendingUp",
    streams: [
      "Company Secretary",
      "ACCA (9 Paper Exemption)",
      "Aviation & Hospitality Mgmt.",
      "Digital Marketing with AI",
    ],
  },
  {
    code: "BBA-HONS",
    title: "BBA (Hons.)",
    sub: "Business Administration",
    icon: "Briefcase",
    streams: [
      "Aviation & Hospitality Mgmt.",
      "Logistics Management",
      "Digital Marketing with AI",
    ],
  },
  {
    code: "BSC-PSY",
    title: "B.Sc Psychology (Hons.)",
    sub: "Psychology & Counselling",
    icon: "Brain",
    streams: [
      "Diploma in Human Psychology & Counselling",
      "Advanced Diploma in Psychological Counselling",
    ],
  },
  {
    code: "BSW",
    title: "Bachelor of Social Work (Hons.)",
    sub: "Social Work",
    icon: "HeartHandshake",
    streams: [
      "Diploma in Human Psychology & Counselling",
      "CSR for Social Impact & Community Development",
      "Advanced Diploma in Psychological Counselling",
    ],
  },
];

export const PG_PROGRAMS = [
  {
    title: "MTTM",
    full: "Master of Tourism & Travel Management",
    icon: "Plane",
  },
  {
    title: "M.Com",
    full: "Finance & Taxation · ICSI Study Centre Approved",
    icon: "Calculator",
  },
  {
    title: "MCA*",
    full: "Master of Computer Application",
    icon: "Cpu",
  },
  {
    title: "MSW",
    full: "Master of Social Work",
    icon: "Users",
  },
];

export const ACHIEVEMENTS = {
  ranks: [
    { name: "Athulya Babu", program: "Bachelor of Social Work" },
    { name: "P. Sree Lakshmi", program: "Bachelor of Social Work" },
    { name: "Gouthami Gangadharan", program: "B.Sc Computer Science" },
  ],
  scholarship: {
    name: "Lida Kuriakose",
    program: "BSW 2020-23",
    award: "Chief Minister's Merit Scholarship",
    amount: "₹1,00,000",
  },
  sports: [
    { name: "Jomol Joseph", detail: "Bronze · 6th KKA State Karate 2025 (+68Kg)" },
    { name: "Jojomol Joseph", detail: "Bronze · 6th KKA State Karate 2025 (+68Kg)" },
    { name: "Jitsal Jith Samuvel", detail: "3rd · State Cycle Polo Championship" },
    { name: "Angelene Seby", detail: "Silver · MG Univ. Arm-wrestling 2025-26" },
    { name: "Akshai Biju", detail: "1st Runner Up · MG Univ. Best Physique" },
    { name: "Raeez C Z", detail: "3rd · District Cycle Polo Championship" },
    { name: "Sruthin P. Murali", detail: "Silver · Arm-wrestling University" },
    { name: "Pranav P. Prasanth", detail: "Hammer Throw Gold · Discus Silver · AAA District" },
  ],
  kalolsavam: [
    { name: "Vrinda R Nair", event: "Bharathanatyam · II BCA" },
    { name: "Devika Vinod", event: "Kathaprasangam & Hindi Poetry · III BSW" },
    { name: "Hendrik Binoj", event: "Kavithaparayanam Malayalam · III BSW" },
    { name: "Riya Raphael", event: "English Essay Writing · II B.Sc Psy" },
  ],
};

export const FACILITIES = [
  { name: "ICT Classrooms", icon: "Monitor" },
  { name: "Central Library", icon: "BookOpen" },
  { name: "A/C Computer Lab", icon: "Server" },
  { name: "A/C Seminar Hall", icon: "Presentation" },
  { name: "A/C Auditorium", icon: "Theater" },
  { name: "Canteen", icon: "Coffee" },
  { name: "College Bus", icon: "Bus" },
  { name: "Playground", icon: "Trophy" },
  { name: "Hostel Facility", icon: "Building2" },
];

export const CLUBS = [
  "Alumni Association",
  "Parents Teachers Association",
  "Entrepreneurship Development Club",
  "Nature Club",
  "Tourism Club",
  "Health Club",
  "Reading Club",
  "Dance Club",
  "Music Club",
  "Film Club",
  "Sports Club",
  "Campus Radio",
  "NCC",
  "NSS",
];

export const CELLS = [
  "Career Guidance & Placement Cell",
  "Grievance Redressal Committee",
  "Ethics Committee",
  "Women Empowerment Cell",
  "Equal Opportunity Cell",
  "Anti-Ragging Cell",
  "Anti-Drug Cell",
  "ASAP Cell",
  "IIC",
  "IEDC",
];

export const WHY_US = [
  {
    title: "Industry-Aligned Curriculum",
    desc: "AI, Robotics, Cybersecurity & Data Science integrated into honours programs — graduates job-ready for the next decade.",
    icon: "Sparkles",
  },
  {
    title: "Merit Scholarships",
    desc: "Attractive scholarships for excellence in Academics, Arts and Sports including state-recognised merit awards.",
    icon: "Award",
  },
  {
    title: "Advanced Infrastructure",
    desc: "A/C smart classrooms, computer labs, seminar halls and auditorium — built for modern learning.",
    icon: "Building2",
  },
  {
    title: "Holistic Development",
    desc: "Curricular, co-curricular and extra-curricular activities aligned with human values & ethical thinking.",
    icon: "Compass",
  },
  {
    title: "Strong Industry Tie-ups",
    desc: "ICSI approved study centre · ACCA exemptions · Placement & Career Guidance Cell.",
    icon: "Network",
  },
  {
    title: "Vibrant Campus Life",
    desc: "14 clubs, 10 cells & committees, NCC, NSS, Campus Radio and state-level sports recognition.",
    icon: "Radio",
  },
];
